import {
  PlusOutlined,
  ScheduleOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Modal, Space, Button, Typography } from 'antd';
import { Link } from 'react-router-dom';

import { CloseIconsForModalWithDataTestId } from '@app/components/CloseIconsForModalWithDataTestId';
import type { EmployeeSetupHintModalProps } from '@app/components/Modals/EmployeeSetupHintModal/types';
import { SERVICES_PATH, SCHEDULE_PATH } from '@app/constants';
import { generateSpanWithDataTestId } from '@app/shared/utils';

const { Text } = Typography;

export const EmployeeSetupHintModal: React.FC<EmployeeSetupHintModalProps> = ({
  isOpen,
  onClose,
  accessRightsPath,
  servicesPath = SERVICES_PATH,
}) => {
  return (
    <Modal
      data-testid="attention-popup"
      title={generateSpanWithDataTestId(
        'Обратите внимание!',
        'attention-popup-title'
      )}
      open={isOpen}
      footer={[
        <Button key="ok" type="default" onClick={onClose} data-testid="not-now">
          Не сейчас
        </Button>,
      ]}
      onCancel={onClose}
      width={400}
      closeIcon={<CloseIconsForModalWithDataTestId />}
    >
      <Space
        direction="vertical"
        size={0}
        style={{ width: '100%' }}
        data-testid="attention-popup-description"
      >
        <Text>
          После добавления исполнителя необходимо выполнить следующие действия:
        </Text>
        <ul>
          <li>Прикрепить услуги</li>
          <li>Настроить график работы</li>
          <li>Настроить права доступа</li>
        </ul>
        <Text>
          Только при наличии перечисленных настроек исполнителю можно будет
          назначать записи.
        </Text>

        <Space
          direction="vertical"
          size="small"
          style={{ width: '100%', marginTop: '16px' }}
        >
          <Button
            type="primary"
            block
            icon={<PlusOutlined />}
            data-testid="attach-services"
          >
            <Link to={servicesPath} target="_blank" rel="noopener noreferrer">
              Прикрепить услуги
            </Link>
          </Button>

          <Button
            type="primary"
            block
            icon={<ScheduleOutlined />}
            data-testid="configure-schedule"
          >
            <Link to={SCHEDULE_PATH} target="_blank" rel="noopener noreferrer">
              Настроить график работы
            </Link>
          </Button>

          <Button
            type="primary"
            block
            icon={<UserOutlined />}
            data-testid="configure-access"
          >
            <Link
              to={accessRightsPath}
              target="_blank"
              rel="noopener noreferrer"
            >
              Настроить права доступа
            </Link>
          </Button>
        </Space>
      </Space>
    </Modal>
  );
};
